import cn from 'classnames'
import { memo, useMemo } from 'react'

import { IContentProps } from './models'

import styles from './Content.module.scss'

export const Content = memo<IContentProps>(
  ({ classes, keepMounted, activeItemId, items, sharedItems }) => {
    const activeItem = useMemo(
      () => items.find((item) => item.id === activeItemId) ?? null,
      [activeItemId, items]
    )

    return (
      <div className={cn(styles.content, classes?.content)}>
        <div className={styles.shared}>{sharedItems}</div>
        {keepMounted &&
          items.map((item) => {
            return (
              <div
                key={`${item.logicalIndex}-${String(item.id)}`}
                style={{
                  height: '100%',
                  display: item.id === activeItemId ? 'block' : 'none',
                }}
              >
                {item.child}
              </div>
            )
          })}
        {!keepMounted ? (activeItem?.child ?? null) : null}
      </div>
    )
  }
)

Content.displayName = 'Content'
